export class SIQFileMessageTheme {
  incomingTitleColor = "null";
  incomingSubTitleColor = "null";
  outgoingTitleColor = "null";
  outgoingSubTitleColor = "null";
  incomingFileViewBackgroundColor = "null";
  outgoingFileViewBackgroundColor = "null";
  incomingCommentBackgoundColor = "null";
  outgoingCommentBackgoundColor = "null";
}
//# sourceMappingURL=SIQFileMessageTheme.js.map